

export default {
  data() {
      return {
        selectedPrimaryPost: null,
        selectedSecondaryPost: null,
        selectedTertiaryPost: null,
        selectedMenuData: null,

        searchQuery: '',

        depth: 0,
        primaryMenuHeight: 300,

        selectedMenu0: null,
        selectedMenu1: null,
        selectedMenu2: null,
        selectedMenu3: null,
      };
  },

  props: {
    menuData: {
      type: Array,
      default: function() {
        return [];
      },
    },
    currentId: {
      type: Number,
      default: -1,
    },
  },

  computed: {
    menuForDepth1: function() {
      return (this.selectedMenu0) ? this.selectedMenu0.children : [];
    },
    menuForDepth2: function() {
      return (this.selectedMenu1) ? this.selectedMenu1.children : [];
    },
    menuForDepth3: function() {
      return (this.selectedMenu2) ? this.selectedMenu2.children : [];
    },
  },

  watch: {
    depth: function (newValue, oldValue) { // eslint-disable-line no-unused-vars
      //this.layoutSubviews();
    },
  },

  methods: {
    layoutSubviews: function () {
      var height = 0;
      height = this.$refs['menuDepth'+this.depth].clientHeight;
      this.primaryMenuHeight = height;
    },
    didSelectBack: function() {
      if(this.depth > 0) {
        this.depth -= 1;
      }
    },
    didSelectPost: function(item, ignoreChildren = false) {
      const self = this;

      if(item.children && !ignoreChildren) {

        var newDepth = item.depth+1;

        switch (newDepth) {
          case 1: {
            self.selectedMenu0 = item;
          } break;

          case 2: {
            self.selectedMenu1 = item;
          } break;

          case 3: {
            self.selectedMenu2 = item;
          } break;

          default:

        }

        self.depth = newDepth;

        return;
      }

      window.location.href = item.url;
    },
  },

  components: {
    //PoseTransition,
  },

  mounted() {
/*
    var self = this;

    window.addEventListener('load', () => {
      self.layoutSubviews();
    })
*/

    var self = this;
    setTimeout(function() {
      self.layoutSubviews();
    }, 150);


  },

  updated() {
    this.layoutSubviews();
  },
};




// WEBPACK FOOTER //
// ./scripts/vue/MobileMenu.vue